/**
 * Takes in any number and returns a number with a maximum of 3 decimal places
 * 
 * @param {number} num 
 * @returns {number} number with maximum 3 decimal places
 * 
 * @category Utils
 */
export const formatDecimalPlaces = (num, decimalPlaces = 3) => {
    if(num !== 0 && !num) return

    return Number(num.toFixed(decimalPlaces))
}